export const primary = {
  100: '#EFD3FD',
  200: '#DDB6F1',
  300: '#D29CED',
  400: '#CE93EC',
  500: '#AB46D7',
  600: '#943BBB',
  700: '#7E319F',
  800: '#682784',
  900: '#4C0062',
  gradient: 'linear-gradient(-61deg, #AB46D7 0%, #4C0062 100%)',
};

export const secondary = {
  100: '#FFFFCC',
  200: '#FBFB6A',
  300: '#F6C500',
};

export const warning = {
  100: '#FCEDCC',
  200: '#FCE4A3',
  300: '#FCDB7A',
  400: '#FBD151',
  500: '#FBC828',
  600: '#E6A524',
  700: '#CC821F',
  800: '#9A5F1B',
  900: '#6D3C16',
};

export const error = {
  100: '#FFD6DD',
  200: '#F7B3B6',
  300: '#F5959B',
  400: '#F27480',
  500: '#EB4763',
  600: '#BD2D48',
  700: '#A1253C',
  800: '#861D30',
  900: '#6B1525',
};

export const success = {
  100: '#E1F5E3',
  200: '#BFEBC4',
  300: '#A4DDAC',
  400: '#96D39E',
  500: '#67B77A',
  600: '#4F8E5E',
  700: '#437B51',
  800: '#386843',
  900: '#2D5537',
};

export const info = {
  100: '#D5E6FF',
  200: '#A6C9FE',
  300: '#87B6FE',
  400: '#71A8F4',
  500: '#3D8AF1',
  600: '#2370D6',
  700: '#1A5AAE',
  800: '#134489',
  900: '#0D3773',
};

export const neutral = {
  0: '#FFFFFF',
  100: '#E9EAEC',
  200: '#C2C4CC',
  300: '#A8ABB6',
  400: '#8E92A0',
  500: '#5D6277',
  600: '#484C5F',
  700: '#343746',
  800: '#21242E',
  900: '#101118',
};

export const status = {
  todo: neutral[100],
  progress: info[400],
  concluded: success[500],
};

export const colors = {
  neutral,
  error,
  warning,
  primary,
  secondary,
  success,
  status,
  info,
};
